import { useSyncExternalStore, useMemo } from 'react';

// Breakpoints
const BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
};

// Cached snapshot to avoid infinite loop
let cachedSnapshot = {
  width: typeof window !== 'undefined' ? window.innerWidth : 0,
  height: typeof window !== 'undefined' ? window.innerHeight : 0,
};

// External store for window size
const windowSizeStore = {
  getSnapshot() {
    // Return cached snapshot to avoid creating new object on every call
    return cachedSnapshot;
  },

  getServerSnapshot() {
    return {
      width: 0,
      height: 0,
    };
  },

  subscribe(callback) {
    const handleResize = () => {
      // Update cached snapshot on resize
      cachedSnapshot = {
        width: window.innerWidth,
        height: window.innerHeight,
      };
      callback();
    };

    window.addEventListener('resize', handleResize, {
      passive: true,
    });
    return () => window.removeEventListener('resize', handleResize);
  },
};

export function useResponsive() {
  const windowSize = useSyncExternalStore(
    windowSizeStore.subscribe,
    windowSizeStore.getSnapshot,
    windowSizeStore.getServerSnapshot,
  );

  return useMemo(
    () => ({
      isMobile: windowSize.width < BREAKPOINTS.mobile,
      isTablet:
        windowSize.width >= BREAKPOINTS.mobile &&
        windowSize.width < BREAKPOINTS.tablet,
      isDesktop: windowSize.width >= BREAKPOINTS.tablet,
      width: windowSize.width,
      height: windowSize.height,
    }),
    [windowSize.width, windowSize.height],
  );
}
